import { useParams, useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import GlowEffect from "../components/common/GlowEffect";
import { useAboutData, Person } from "../hooks/useAboutData";

function PersonDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data } = useAboutData();

  // Find the person in boardOfAdvisors or team members
  const allPeople = [
    ...data.boardOfAdvisors.people,
    ...data.team.members.map((member) => ({
      ...member,
      id: member.name.toLowerCase().replace(/\s+/g, "-"),
      subtitle: "",
      description: "",
      fullDescription: [],
    })),
  ];

  const person = allPeople.find((p: Person) => p.id === id);

  if (!person) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">Person Not Found</h1>
          <button
            onClick={() => navigate("/about-us")}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Back to About Us
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="text-white">
      {/* Close Button */}
      <div className="absolute top-0 right-16 z-50">
        <button onClick={() => navigate("/about-us")}>
          <X
            className="absolute top-8 w-12 h-12 text-white rounded-full flex items-center justify-center transition-all duration-300"
            size={24}
          />
        </button>
      </div>

      {/* Main Content */}
      <div className="px-6 md:px-14 pt-16 pb-10 relative">
        <GlowEffect />
        <div className="flex flex-wrap md:flex-nowrap gap-12 items-end">
          {/* Image Section */}
          <div className="flex justify-center">
            <div className="relative">
              <img
                src={person.image}
                alt={person.name}
                className="w-full h-auto object-cover shadow-2xl"
              />
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>

          {/* Content Section */}
          <div className="space-y-3">
            <h1 className="text-4xl md:text-8xl font-bold mb-2">
              {person.name}
            </h1>
            <p className="text-2xl md:text-5xl mb-1">{person.title}</p>
            <p className="text-2xl md:text-5xl word-wrap">
              {"| "}
              {person.subtitle}
            </p>
          </div>
        </div>
        {Array.isArray(person?.fullDescription) ? (
          <div className="py-14">
            {person.fullDescription.map((desc, index) => (
              <p
                key={index}
                className="text-xl font-medium leading-relaxed py-2"
              >
                {desc}
              </p>
            ))}
          </div>
        ) : (
          <p className="text-xl font-medium leading-relaxed py-14">
            {person?.fullDescription || person?.description}
          </p>
        )}
      </div>
    </div>
  );
}

export default PersonDetailPage;
